/*
 * Filename: /Users/mafo/Documents/03-teamshufflr/04-Code/teamshufflr/libs/common/services/cookie/src/tokens
 * Path: /Users/mafo/Documents/03-teamshufflr/04-Code/teamshufflr/libs/common
 * Created Date: Saturday, January 15th 2022, 11:26:18 am
 * Author: Maximilian Fossler
 *
 * Copyright (c) 2022 teamshufflr
 */

import { InjectionToken } from '@angular/core';
import { TsCookieOptions } from './interfaces/cookie-options';
import { ITsCookieWriterService } from './interfaces/cookie-writer-service';

export const TS_COOKIE_OPTIONS = new InjectionToken<TsCookieOptions>(
  'TS_COOKIE_OPTIONS'
);
export const TS_COOKIE_WRITER = new InjectionToken<ITsCookieWriterService>(
  'TS_COOKIE_WRITER'
);
